import React from 'react';
import {
  Create,
  SimpleForm,
  TextInput,
  NumberInput,
  ReferenceArrayInput,
  SelectArrayInput,
  DateInput,
} from 'react-admin';
import { required } from '../../lib/validation';

const PromoCreate = props => (
  <Create {...props}>
    <SimpleForm>
      <TextInput source="code" validate={required()} />
      <NumberInput source="amount" validate={required()} />
      <DateInput label="Start at" source="start_at" validate={required()} />
      <DateInput label="End at" source="end_at" validate={required()} />
      <ReferenceArrayInput label="Plans" source="plan_ids" reference="plans" validate={required()}>
        <SelectArrayInput optionText="name" />
      </ReferenceArrayInput>
    </SimpleForm>
  </Create>
);

export default PromoCreate;



// WEBPACK FOOTER //
// ./src/resources/promos/PromoCreate.jsx